import { AutomationTagGeneratorBase, generateAutomationName } from "../../helpers/generateAutomationName";

export const CompetitorsStepKeys = {
    mainWrapper: generateAutomationName("activation", ["setup", "ai", "competitors", "main", "wrapper"]),
    title: generateAutomationName("activation", ["setup", "ai", "competitors", "title"]),
    selectorsWrapper: generateAutomationName("activation", ["setup", "ai", "competitors", "selectors", "wrapper"]),
    selectorsTitle: generateAutomationName("activation", ["setup", "ai", "competitors", "selectors", "title"]),
    websiteInputWrapper: generateAutomationName("activation", ["setup", "ai", "competitors", "website", "input"]),
    countrySelectTitle: generateAutomationName("activation", ["setup", "ai", "competitors", "country", "title"]),
    countrySelectDropdown: generateAutomationName("activation", ["setup", "ai", "competitors", "country", "dropdown"]),
    selectCompetitorsTitle: generateAutomationName("activation", ["setup", "ai", "competitors", "select", "title"]),
    selectCompetitorsLimit: generateAutomationName("activation", ["setup", "ai", "competitors", "select", "limit"]),
    autocomplete: generateAutomationName(
        "activation",
        ["setup", "ai", "autocomplete"],
        AutomationTagGeneratorBase.Benchmark,
    ),
    loaderWrapper: generateAutomationName(
        "activation",
        ["setup", "ai", "competitors", "loader"],
        AutomationTagGeneratorBase.Benchmark,
    ),
    competitorsListWrapper: generateAutomationName(
        "activation",
        ["setup", "ai", "competitors", "wrapper"],
        AutomationTagGeneratorBase.Benchmark,
    ),
    competitorsListItem: generateAutomationName(
        "activation",
        ["setup", "ai", "competitors", "item"],
        AutomationTagGeneratorBase.Benchmark,
    ),
    emptyState: generateAutomationName("activation", ["setup", "ai", "competitors", "empty"]),
};
